import { isEmpty } from 'utilities';

/** The new value for an amount when `type` is switched, or undefined to leave it alone.
 *
 * String in, string out — a Number round-trip would drop the decimals the user is looking at
 * ("1234.50" -> "-1234.5"). Distinct from `asCredit`, which SEEDS a known-credit extraction and
 * always returns the negative form: here undefined means "no change needed", not "nothing to set".
 *
 * Zero is left alone: it carries no sign to correct, and "-0.00" is noise in a field the user
 * did not touch. */
export function resignAmount(value: unknown, credit: boolean): string | undefined {
  if (isEmpty(value)) {
    return undefined;
  }
  const s = String(value).trim().replace(/^\+/, '');
  // anything the user is mid-typing ("-", "1.", "abc") is left for the validator to reject
  if (!/^-?(\d+\.?\d*|\.\d+)$/.test(s) || Number(s) === 0) {
    return undefined;
  }
  const negative = s.startsWith('-');
  if (negative === credit) {
    return undefined;
  }
  return credit ? `-${s}` : s.slice(1);
}
